// Matches content-disposition header according to RFC 6266:
// `attachment; filename="example.pdf"; filename*=UTF-8''example.pdf`
const CONTENT_DISPOSITION_REGEX = new RegExp(
    [
        // Match semicolon and optional linear whitespace
        ';\\s*',
        // Capture parameter name (before '=' or whitespace)
        '([^=\\s]+)',
        // '=' and optional whitespace
        '\\s*=\\s*',
        // Capture parameter value:
        // - Quoted string (handles escaped quotes and backslashes)
        // - Unquoted value (extends to next semicolon or end of string)
        '("(?:[^"\\\\]|\\\\.)*"|[^;]+)',
    ].join(''),
    'g',
);

export function parseContentDispositionParameters(header: string): Record<string, string> {
    const parameters: Record<string, string> = {};

    CONTENT_DISPOSITION_REGEX.lastIndex = 0;

    for (
        let match = CONTENT_DISPOSITION_REGEX.exec(header);
        match !== null;
        match = CONTENT_DISPOSITION_REGEX.exec(header)
    ) {
        const [, rawKey, rawValue] = match;
        const key = rawKey.trim().toLowerCase();
        const value = stripOuterQuotes(rawValue.trim());
        parameters[key] = value;
    }

    return parameters;
}

export function stripOuterQuotes(raw: string): string {
    const value = raw.trim();
    const hasQuotes = value.startsWith('"') && value.endsWith('"');
    return hasQuotes ? value.slice(1, -1) : value;
}
